// removed by extract-text-webpack-plugin
module.exports = {"prompt":"_-pages-PostTruck-compontents-Prompt-prompt","success":"_-pages-PostTruck-compontents-Prompt-success","info":"_-pages-PostTruck-compontents-Prompt-info","warning":"_-pages-PostTruck-compontents-Prompt-warning","error":"_-pages-PostTruck-compontents-Prompt-error","icon":"_-pages-PostTruck-compontents-Prompt-icon","content":"_-pages-PostTruck-compontents-Prompt-content","close":"_-pages-PostTruck-compontents-Prompt-close","message":"_-pages-PostTruck-compontents-Prompt-message","description":"_-pages-PostTruck-compontents-Prompt-description"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PostTruck/compontents/Prompt/style.css
// module id = 1880
// module chunks = 0